/**
 * Recarga la pestaña actual.
 *
 * En su propio módulo (y no inline en el hook) para que los tests
 * puedan simularla: `window.location` de jsdom es no configurable
 * y no admite `vi.spyOn` sobre `reload`.
 */
export function recargarPagina(): void {
  window.location.reload();
}
